export default __webpack_public_path__ + "static/media/engine1.4e67d877.jpg";